import { authService } from './authService';
import { getServerURL } from './config';

class BlockBlobClient {
  constructor(filename) {
    this.filename = filename;
  }

  async uploadBrowserData(file, options = {}) {
    const contentType = options?.blobHTTPHeaders?.blobContentType || file?.type || 'application/octet-stream';
    const formData = new FormData();
    formData.append('filename', this.filename);
    formData.append('contentType', contentType);
    formData.append('file', file, file?.name || this.filename.split('/').pop() || 'upload');
    const headers = authService.getAuthHeaders();
    delete headers['Content-Type'];

    const response = await fetch(`${getServerURL()}/settings/design/designer/upload`, {
      method: 'POST',
      headers,
      body: formData
    });
    const payload = await response.json();

    if (!response.ok || !payload?.success || !payload?.data?.publicUrl) {
      throw new Error(payload?.error || 'Failed to upload file');
    }

    return {
      requestId: response.headers.get('x-request-id') || '',
      publicUrl: payload.data.publicUrl
    };
  }
}

class ContainerClient {
  getBlockBlobClient(filename) {
    return new BlockBlobClient(filename);
  }
}

export class BlobServiceClient {
  getContainerClient() {
    return new ContainerClient();
  }
}
